import { MobileOnlyOptions } from "./MobileOnlyOptions";
import { USALandingOptions } from "./USALandingOptions";
import type { LandingPageConfigOptions } from "landing/objects/LandingPageConfig";

export const LandingPageTemplate20: LandingPageConfigOptions = {
  consentAge: 19,
  ...MobileOnlyOptions,
  ...USALandingOptions,
};
